var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftDecoration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 43,
  fill: "none",
  viewBox: "0 0 37 43"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F8C1B8",
  fillRule: "evenodd",
  d: "M29.869 30.121c.57 1.098.16 2.45-.915 3.022l-12.22 6.494c-1.075.572-2.409.146-2.978-.952s-.16-2.45.915-3.021l12.22-6.495c1.075-.571 2.408-.145 2.978.952",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00664F",
  fillRule: "evenodd",
  d: "M28.616 27.894c.57 1.097.16 2.45-.915 3.022L15.48 37.41c-1.075.572-2.409.145-2.979-.952s-.16-2.45.915-3.022l12.22-6.494c1.075-.572 2.409-.145 2.979.952",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8C1B8",
  fillRule: "evenodd",
  d: "M26.695 17.398c-.06 1.235-1.096 2.197-2.313 2.148l-13.827-.548c-1.217-.049-2.154-1.089-2.093-2.324s1.096-2.197 2.313-2.149l13.827.549c1.217.048 2.154 1.089 2.093 2.324",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00664F",
  fillRule: "evenodd",
  d: "M26.735 14.842c-.06 1.235-1.096 2.197-2.313 2.149l-13.827-.549c-1.217-.048-2.154-1.088-2.093-2.323s1.096-2.197 2.313-2.15l13.827.55c1.217.048 2.154 1.088 2.093 2.323",
  clipRule: "evenodd"
})));
export default SvgLeftDecoration;